import React from "react";
import Alert from "react-bootstrap/Alert";
const ErrorValidation = ({ type, errormsg, isDefaultErrMsg=true }) => {
  return (
    (isDefaultErrMsg)?  DefaultError(type) :CustomError(type,errormsg)
    
  );
};

const DefaultError= (type)=>{
  return(
    <Alert variant={type}>
      {" "}
      <span className="" data-testid="errmsgcontainer">
        The application has encountered an unexpected error. Please try again
        after a short time, or You can contact us{" "}
        <Alert.Link
          style={{ color: "#004589", fontWeight: "600" }}
          href={`mailto:${process.env.REACT_APP_EMAIL_ADDRESS}?subject=${process.env.REACT_APP_EMAIL_SUBJECTS}`}
        >
          via email
        </Alert.Link>{" "}
        or call {`${process.env.REACT_APP_SUPPORT_PHONE}`} for assistance.
      </span>
    </Alert>
  )
}

const CustomError= (type,errMsg)=>{
  if(errMsg=="INVALID_CASE_ERROR")
  {
    return(        
      <Alert variant={type}>
        {" "}
        We cannot find that case
        <p className="pt-1 small mb-0"  data-testid="errmsgcontainer">
        The provided Last Name and Case Number is incorrect. Please check Patient Last Name (Can be found on our letter) 
        and Subro Portal Case # (Can be found on our fax coversheet.) If you do not have this information please contact us{" "}
          <Alert.Link
            style={{ color: "#004589", fontWeight: "600" }}
            href={`mailto:${process.env.REACT_APP_SUBRO_EMAIL_ADDRESS}?subject=${process.env.REACT_APP_EMAIL_SUBJECTS}`}
          >
            via email
          </Alert.Link>{" "}
          or call {`${process.env.REACT_APP_SUBRO_FAX}`} for assistance.
        </p>
      </Alert>
    );
  }
  else if(errMsg=="CASE_NOT_FOUND_ERROR")
  {
    return(  
      <Alert variant={type}>
      {" "}
      We cannot find that case
      <p className="pt-1 small mb-0"  data-testid="errmsgcontainer">
      The Information provided does not match any cases we have in our system.  
      Please try again or you can contact us{" "}
        <Alert.Link
          style={{ color: "#004589", fontWeight: "600" }}
          href={`mailto:${process.env.REACT_APP_SUBRO_EMAIL_ADDRESS}?subject=${process.env.REACT_APP_EMAIL_SUBJECTS}`}
        >
          via email
        </Alert.Link>{" "}
        or call {`${process.env.REACT_APP_SUBRO_FAX}`} for assistance.
      </p>
    </Alert>
    );
  }  
  else if(errMsg=="CASE_COMM_NOT_FOUND_ERROR")
    {
      return(  
        <Alert variant={type}>
        {" "}
        We cannot find that case
        <p className="pt-1 small mb-0"  data-testid="errmsgcontainer">
        The Information provided does not match any Case Communication ID we have in our system.  
        Please try again or you can contact us{" "}
          <Alert.Link
            style={{ color: "#004589", fontWeight: "600" }}
            href={`mailto:${process.env.REACT_APP_SUBRO_EMAIL_ADDRESS}?subject=${process.env.REACT_APP_EMAIL_SUBJECTS}`}
          >
            via email
          </Alert.Link>{" "}
          or call {`${process.env.REACT_APP_SUBRO_FAX}`} for assistance.
        </p>
      </Alert>
      );
    }    
  else if (errMsg == "CASE_COMM_NOT_FOUND_ERROR_WITH_VALID_CASEID") {
    return (
      <Alert variant={type}>
        {" "}
        Access Restricted
        <p className="pt-1 small mb-0" data-testid="errmsgcontainer">
          The Case Communication ID you entered is valid, but access is limited to authorized recipients.
          Please try another ID or you can contact us{" "}
          <Alert.Link
            style={{ color: "#004589", fontWeight: "600" }}
            href={`mailto:${process.env.REACT_APP_SUBRO_EMAIL_ADDRESS}?subject=${process.env.REACT_APP_EMAIL_SUBJECTS}`}
          >
            via email
          </Alert.Link>{" "}
          or call {`${process.env.REACT_APP_SUBRO_FAX}`} for assistance.
        </p>
      </Alert>
    );
  }  
};

export default ErrorValidation;
